import emptySliceApi from '../../store/emptyApiSlice';

interface ResolveClientTokenRequest {
  clientTokenId: string;
  routeType: 'rbac' | 'b2b';
}

interface ResolveClientTokenResponse {
  token: string;
}

export const apiSlice = emptySliceApi.injectEndpoints({
  endpoints: (builder) => ({
    resolveClientToken: builder.mutation<
      ResolveClientTokenResponse,
      ResolveClientTokenRequest
    >({
      query: ({ clientTokenId, routeType }) => ({
        url: 'tokens/resolve-client-token',
        method: 'POST',
        body: { clientTokenId, routeType },
      }),
    }),
    validateToken: builder.mutation<void, string>({
      query: (token) => ({
        validateStatus: (res) => res.status === 204,
        headers: {
          authorization: `Bearer ${token}`,
        },
        url: 'tokens/validate',
        method: 'POST',
      }),
    }),
  }),
});

export const { useResolveClientTokenMutation, useValidateTokenMutation } =
  apiSlice;
